export const reviewsData = [
  {
    id: 1,
    name: "Дмитрий К.",
    casino: "Fugu",
    rating: 5,
    amount: "127 000 ₽",
    date: "2026-01-14",
    text: "Отыграл бонус 500% за неделю. Вывод прошел за 2 часа на карту. Лучшее предложение, которое я встречал!",
    verified: true
  },
  {
    id: 2,
    name: "Анна М.",
    casino: "SOL",
    rating: 5,
    amount: "89 500 ₽",
    date: "2026-01-13",
    text: "Фриспины зашли на ура! Выиграла почти 90 тысяч на Book of Dead. Вейджер x35 отыграла легко.",
    verified: true
  },
  {
    id: 3,
    name: "Сергей П.",
    casino: "FRESH",
    rating: 4,
    amount: "64 200 ₽",
    text: "Хороший бонус, но пришлось повозиться с отыгрышем. В итоге вывел 64к, доволен результатом.",
    verified: true
  },
  {
    id: 4,
    name: "Елена В.",
    casino: "LEX",
    rating: 5,
    amount: "112 000 ₽",
    date: "2026-01-11",
    text: "200 фриспинов — это просто бомба! Выиграла больше 100 тысяч. Поддержка отличная, вывод быстрый.",
    verified: true
  },
  {
    id: 5,
    name: "Максим Р.",
    casino: "1GO",
    rating: 5,
    amount: "156 000 ₽",
    date: "2026-01-09",
    text: "Бонус на три депозита — гениально! Растянул удовольствие и отыграл все три раза. Рекомендую!",
    verified: true
  },
  {
    id: 6,
    name: "Ольга Т.",
    casino: "IZZI",
    rating: 4,
    amount: "71 800 ₽",
    date: "2026-01-08",
    text: "Простые условия, понятный интерфейс. Отыграла за 5 дней, вывела без проблем.",
    verified: true
  }
];